import { Button, styled } from "@mui/material";

export const StyledCallToAction = styled(Button)({
  margin: "24px 0 32px 0",
});
